import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiClientConfig } from '../../api-client-config';
import { Observable } from 'rxjs';
import { SubmitTreatmentsExtractionRequest } from 'it/primatoo/openapi/api/org/schemas/extraction/SubmitTreatmentsExtractionRequest';
import { SubmitExtractionResponse } from 'it/primatoo/openapi/api/org/schemas/extraction/SubmitExtractionResponse';

@Injectable({
  providedIn: 'root',
})
export class ExtractionService {
  private readonly endpoint: string;


  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient
  ) {
    this.endpoint = this.config.endPoint + '/api/org/v2/extractions/treatments';
  }

  extractions(
    request: SubmitTreatmentsExtractionRequest
  ): Observable<SubmitExtractionResponse> {
    return this.httpClient.post<SubmitExtractionResponse>(
      this.endpoint + '/submit',
      request
    );
  }
}
